import React from 'react';
import {grey500} from 'material-ui/styles/colors';
import FontIcon from 'material-ui/FontIcon';
import Header from 'components/header';


const style = {
    mainIcon: {
        color: grey500,
        fontSize: '20vh',
    },
    body: {
        marginTop: 50,
    },
    message: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        color: grey500,
        transform: 'translate(-50%,-50%)',
        textAlign: 'center'
    },
    arrow: {
        textAlign: 'center',
        color: grey500,
        position: 'absolute',
        bottom: 85,
        left: '50%',
        transform: 'translateX(-50%)'
    }
};

export default function (props) {
    return <div style={style.body}>
        <Header logout={props.logout} avatar={props.avatar}>{props.title}</Header>
        <div className="wt-hide-when-loading" style={style.message}>
            <FontIcon style={style.mainIcon} className="material-icons">{props.icon}</FontIcon>
            <div>{props.children}</div>
        </div>
        <div className="wt-hide-when-loading" style={style.arrow}>
            <div>Click to select media</div>
            <div><FontIcon color={grey500} className="material-icons">arrow_downward</FontIcon></div>
        </div>
    </div>;
}